<script lang="ts">
  import { settings } from "../data/settings";

  export let flags = [];

  $: show = flags.every((item) => $settings[item]);
</script>

{#if show}
  <slot />
{/if}
